import { max, min } from 'd3-array'

/**
 * Constants
 */

// Default dimensions for the chart, establishes an aspect ratio of 0.35
export const DEFAULT_LINE_CHART_WIDTH = 880
export const DEFAULT_LINE_CHART_HEIGHT = 310

// Default grid dimensions
export const DEFAULT_NUMBER_OF_COLUMNS = 12
export const DEFAULT_NUMBER_OF_ROWS = 10

// Default number of axis ticks
export const DEFAULT_NUMBER_OF_TICKS_X_AXIS = 4
export const DEFAULT_NUMBER_OF_TICKS_Y_AXIS = 5

/**
 * Types and Interfaces
 */
export interface LineChartDomain {
  x?: number[] | Date[]
  y?: number[]
}

export type LineChartDataPoint = {
  [key: string]: string | number | Date
}

/**
 * Utility functions
 */
export function getYMinFromData(data, dataSeries) {
  return min(data, (dataPoint) => {
    let yMin
    Object.keys(dataPoint).forEach((prop) => {
      if (dataSeries.includes(prop)) {
        if (yMin === undefined) {
          yMin = dataPoint[prop]
        } else {
          yMin = Math.min(yMin, dataPoint[prop])
        }
      }
    })
    return yMin
  })
}

export function getYMaxFromData(data, dataSeries) {
  return max(data, (dataPoint) => {
    let yMax
    Object.keys(dataPoint).forEach((prop) => {
      if (dataSeries.includes(prop)) {
        if (yMax === undefined) {
          yMax = dataPoint[prop]
        } else {
          yMax = Math.max(yMax, dataPoint[prop])
        }
      }
    })
    return yMax
  })
}

export function getYAxisTickValues(min, max, numTicks) {
  if (typeof min === 'number') {
    return Array(numTicks)
      .fill(0)
      .map((_, i) => min + i * Math.ceil((max - min) / (numTicks - 1)))
  }
}
